(function () {
  let angular = window.angular;
  let $ = window.jQuery;

  Controller.$inject = ['$element', '$timeout', '$uibModal', 'Customer', 'AppUtils', '$translate'];

  angular.module('app').component('deviceSiblingsTable', {
    template:'<div style="position: relative"><div><div class="dataTable-toolbar paddingT0"></div><table id="devices-table" class="table table-hover no-wrap" style="width: 100%"><thead><tr></tr></thead></table></div><spinner css-class="\'dark small\'" style="height: 100px; width: 100px" show="ctrl.loading"></spinner></div>',
    controller: Controller,
    controllerAs: 'ctrl',
    bindings: {
      device: '<',
    },
  });

  function Controller($element, $timeout, $uibModal, Customer, utils, $translate) {
    let vm = this;
    vm.loading = true;

    vm.$onInit = function onInit() {
      if (!vm.device) {
        return;
      }
      getSiblings().then((devices) => {
        vm.devices = devices;
        initTable(devices);
      });
    };

    vm.$onChanges = function (changes) {
      if (changes && changes.device) {
        vm.siblings = getSiblings();
        initTable(vm.siblings);
      }
    };

    function initTable(data) {
      if (vm.dtInstance) {
        vm.dtInstance.clear();
        vm.dtInstance.rows.add(data);
        vm.dtInstance.draw();
        return;
      }

      let dtOptions = {
        dom:
          "<'row'<'col-xs-12 col-sm-6'f><'col-xs-12 col-sm-6 text-right'l>>" +
          "<'row'<'col-xs-12'tr>>" +
          "<'row'<'col-xs-12 col-sm-5'i><'col-xs-12 col-sm-7 text-right'p>>",
        processing: true,
        order: [1, 'asc'],
        paging: false,
        info: false,
        data: data,
        autoWidth: false,

        columns: [
          {
            title: $translate.instant('entities._all.name'),
            data: 'name',
            width: '50%',
          },
          {
            title: 'ID',
            data: 'id',
            width: '50%',
            render: function (data, type, row) {
              if (type !== 'display') return data;

              if (row.url) {
                return `<a href="${row.url}" target="_blank">${data}</a>`;
              }

              return `<span class="copy-id" data-id="${data}" style="cursor:pointer;text-color:red">
              ${data}
            </span>`;
            },
          },
        ],
        columnDefs: [
          {
            targets: 1, // Name
          },
          {
            targets: 0, // ID
          },
        ],
        responsive: {},
      };

      let table = $element.find('#devices-table');
      let dtInstance = (vm.dtInstance = table.DataTable(dtOptions));

      $element.on('click', '.copy-id', function () {
        const $el = $(this);
        const id = $el.data('id');

        navigator.clipboard.writeText(id);

        $el.text($translate.instant('general.copied') + ' ✔✔');
        setTimeout(() => $el.text(id), 1000);
      });

      $timeout(function () {
        vm.loading = false;
      }, 300);
    }

    async function getSiblings(params) {
      return Customer.prototype$getDeviceSiblings({
        id: vm.device.customerId,
        nk: vm.device.id,
      }).$promise;
    }
  }
})();
